import { combineReducers } from 'redux';
import * as MasterData from '_reducers/masterData.reducer';
import * as NotesReqApproval from '_reducers/notesReqApproval.reducer';
import * as NotesReqApprovalMsgs from '_reducers/notesReqApprovalMsgs.reducer';
import * as NotesPendingAction from '_reducers/notesPendingAction.reducer';
import * as NotesPendingActionMsgs from '_reducers/notesPendingActionMsgs.reducer';
import * as AuthenticationReducer from '_reducers/authentication.reducer';
import * as QuickSearchReducer from '_reducers/quickSearch.reducer';
import * as SearchReducer from '_reducers/search.reducer';
import * as PatientsReducer from '_reducers/patients.reducer';
import * as AdmissionsReducer from '_reducers/admissions.reducer';
import * as DiagnosisReducer from '_reducers/diagnosis.reducer';
import * as InsuredReducer from '_reducers/insured.reducer';
import * as CaseMgrsReducer from '_reducers/caseMgrs.reducer';
import * as AuthsReducer from '_reducers/auths.reducer';
import * as PocsReducer from '_reducers/pocs.reducer';
import * as FotoSurveysReducer from '_reducers/fotoSurveys.reducer';
import * as CdvReducer from '_reducers/cdv.reducer';
import * as DiaryReducer from '_reducers/diary.reducer';
import * as ScansReducer from '_reducers/scans.reducer';
import * as ApptHistReducer from '_reducers/apptHist.reducer';
import * as PeerReviewsReducer from '_reducers/peerReviews.reducer';
import * as PeerReviewMsgsReducer from '_reducers/peerReviewMsgs.reducer';
import * as TrtCodesReducer from '_reducers/trtCodes.reducer';
import * as PdfsReducer from '_reducers/pdfs.reducer';
import * as AlReducer from '_reducers/al.reducer';
import * as TransferEvalsReducuer from '_reducers/transferEvals.reducer';
import * as PrepopulateEvalsReducuer from '_reducers/prepopulateEvals.reducer';
import * as NotesReducer from '_reducers/notes.reducer';
import * as DashboardReducer from '_reducers/dashboard.reducer';
import * as PNDueReducer from '_reducers/pnDue.reducer';
import * as PNDueDetailsReducer from '_reducers/pnDueDetails.reducer';
import * as DCDueReducer from '_reducers/dcDue.reducer';
import * as SpecProgReducer from '_reducers/specProgReqMsgs.reducer';
import * as SpecProgDetailsReducer from '_reducers/specProgReqMsgDetails.reducer';
import * as FederalReviewReducer from '_reducers/federalReviewMsgs.reducer';
import * as FederalReviewAdmissionsReducer from '_reducers/federalReviewMsgAdmissions.reducer';
import * as FederalReviewDetailsReducer from '_reducers/federalReviewMsgDetails.reducer';
import * as MCDiaryReducer from '_reducers/mcDiaryItems.reducer';
import * as FotoEpisodesReducer from '_reducers/fotoEpisodes.reducer';

const reducers = {
    masterData: MasterData.reducer,
    notesReqApproval: NotesReqApproval.reducer,
    notesReqApprovalMsgs: NotesReqApprovalMsgs.reducer,
    notesPendingAction: NotesPendingAction.reducer,
    notesPendingActionMsgs: NotesPendingActionMsgs.reducer,
    authentication: AuthenticationReducer.reducer,
    quickSearch: QuickSearchReducer.reducer,
    search: SearchReducer.reducer,
    patients: PatientsReducer.reducer,
    admissions: AdmissionsReducer.reducer,
    diagnosis: DiagnosisReducer.reducer,
    insured: InsuredReducer.reducer,
    caseMgrs: CaseMgrsReducer.reducer,
    auths: AuthsReducer.reducer,
    pocs: PocsReducer.reducer,
    fotoSurveys: FotoSurveysReducer.reducer,
    cdv: CdvReducer.reducer,
    diary: DiaryReducer.reducer,
    scans: ScansReducer.reducer,
    apptHist: ApptHistReducer.reducer,
    peerReviews: PeerReviewsReducer.reducer,
    peerReviewMsgs: PeerReviewMsgsReducer.reducer,
    trtCodes: TrtCodesReducer.reducer,
    pdfs: PdfsReducer.reducer,
    al: AlReducer.reducer,
    transferEvals: TransferEvalsReducuer.reducer,
    prepopulateEvals: PrepopulateEvalsReducuer.reducer,
    notes: NotesReducer.reducer,
    dashboard: DashboardReducer.reducer,
    pnDue: PNDueReducer.reducer,
    pnDueDetails: PNDueDetailsReducer.reducer,
    dcDue: DCDueReducer.reducer,
    specProgReqMsgs: SpecProgReducer.reducer,
    specProgReqMsgDetails: SpecProgDetailsReducer.reducer,
    federalReviewMsgs: FederalReviewReducer.reducer,
    federalReviewMsgAdmissions: FederalReviewAdmissionsReducer.reducer,
    federalReviewMsgDetails: FederalReviewDetailsReducer.reducer,
    mcDiaryItems: MCDiaryReducer.reducer,
    fotoEpisodes: FotoEpisodesReducer.reducer,
};

export const reducer = combineReducers(reducers);